import { render, staticRenderFns } from "./checkOldRecord.vue?vue&type=template&id=0095e980&"
import script from "./checkOldRecord.vue?vue&type=script&lang=js&"
export * from "./checkOldRecord.vue?vue&type=script&lang=js&"
import style0 from "./checkOldRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports